const TablePlaceholder = ({ colSpan = 8 }) => {
    return (
        <tbody className="relative divide-y-2 divide-white dark:divide-icoDarkMode-anthracite">
            {[...Array(5).keys()].map((idx) => (
                <tr key={idx} className="relative h-[73px] pb-0.5 pt-px">
                    <td colSpan={colSpan} className="relative">
                        <span className="absolute inset-0 w-full animate-pulse bg-icoGray-100 dark:bg-icoDarkMode-deepBlack" />
                    </td>
                </tr>
            ))}
        </tbody>
    );
};

export default TablePlaceholder;
